<template>
  <employee-profile v-bind:selected-role="employeeBasic.initialRoleId">
    <modal-dialog-prevent-leave
      v-bind:is-shown="isShownDialogLeaveConfirm"
      v-on:back="isShownDialogLeaveConfirm = false"
      v-on:leave="leaveWithoutSave"
      v-on:save="saveAndLeave" />
    <section class="employee-basic">
      <p
        v-if="isBranch"
        class="employee-basic__status-title">
        Редактирование недоступно.
        Внесение изменений возможно только в основном филиале трудоустройства сотрудника
      </p>
      <form
        class="employee-basic__form"
        v-on:submit.prevent="onSubmitEmployeeBasicEdit"
      >
        <div class="employee-basic__row">
          <label
            class="employee-basic__group"
            v-bind:class="{ field_error: surnameInputErrors.length > 0 }"
          >
            <span class="employee-basic__label">Фамилия</span>
            <input
              v-bind:disabled="isBranch"
              class="employee-basic__input"
              placeholder=""
              type="text"
              v-model="employeeBasic.surname"
              v-on:input="checkProfileChanged"
              v-letter-capital />
            <p
              class="employee-basic__error-text"
              role="alert"
              v-bind:key="id"
              v-for="(text, id) in surnameInputErrors"
            >{{ text }}</p>
          </label>
          <label
            class="employee-basic__group"
            v-bind:class="{ field_error: nameInputErrors.length > 0 }"
          >
            <span class="employee-basic__label">Имя</span>
            <input
              v-bind:disabled="isBranch"
              class="employee-basic__input"
              placeholder=""
              type="text"
              v-model="employeeBasic.name"
              v-on:input="checkProfileChanged"
              v-letter-capital />
            <p
              class="employee-basic__error-text"
              role="alert"
              v-bind:key="id"
              v-for="(text, id) in nameInputErrors"
            >{{ text }}</p>
          </label>
          <label
            class="employee-basic__group"
            v-bind:class="{ field_error: patronymicInputErrors.length > 0 }"
          >
            <span class="employee-basic__label">Отчество</span>
            <input
              v-bind:disabled="isBranch"
              class="employee-basic__input"
              placeholder=""
              type="text"
              v-model="employeeBasic.patronymic"
              v-on:input="checkProfileChanged"
              v-letter-capital />
            <p
              class="employee-basic__error-text"
              role="alert"
              v-bind:key="id"
              v-for="(text, id) in patronymicInputErrors"
            >{{ text }}</p>
          </label>
        </div>
        <div
          v-if="dataWasLoad"
        >
          <the-select
            v-bind:disabled="isBranch"
            class="employee-basic__multiline"
            title="Выберите роль"
            v-bind:options="employeeRoleList"
            v-bind:value="employeeBasic.roleId"
            v-bind:violations="roleIdInputErrors"
            v-on:input="onInputRole"
          />
        </div>
        <label
          class="employee-basic__group"
          v-if="!isAdmin && !isAssistant"
        >
          <span class="employee-basic__label">Укажите специализацию</span>
          <input
            v-bind:disabled="isBranch"
            class="employee-basic__input"
            placeholder=""
            type="text"
            v-model="employeeBasic.specialtyName"
            v-on:input="checkProfileChanged"
            v-letter-capital />
        </label>
        <div class="employee-basic__row">
          <input-date
            v-bind:disabled="isBranch"
            label="Дата рождения"
            v-bind:violations="birthDateInputErrors"
            v-model="employeeBasic.birthDate"
            v-on:input="checkProfileChanged"
          />
          <input-
            v-if='false'
            v-bind:class="{ 'disable-component': isBranch }"
            v-bind:optional="true"
            v-bind:violations="snilsInputErrors"
            v-model="employeeBasic.snils"
            v-on:input="checkProfileChanged" />
          <input-iin
            v-bind:class="{ 'disable-component': isBranch }"
            v-bind:optional="true"
            v-bind:violations="iinInputErrors"
            v-model="employeeBasic.iin"
            v-on:input="checkProfileChanged" />
        </div>
        <div
          class="employee-basic__contacts"
          v-bind:class="{ align: phoneNumberInputErrors.length > 0 }"
        >
          <input-phone
            v-bind:disabled="isBranch"
            v-if="dataWasLoad"
            v-bind:required="false"
            v-bind:violations="phoneNumberInputErrors"
            v-model="employeeBasic.phoneNumber"
            v-on:input="checkProfileChanged"
          />
          <div
            class="employee-basic__contact__row"
            v-if="isBranch"
          >
            <the-tooltip position="top">
              <template v-slot:trigger="{ listenerObject }">
                <label v-on="listenerObject" class="employee-basic__contact whats-app">
                  <input
                    disabled
                    type="checkbox"
                    v-model="employeeBasic.hasWhatsAppByPhone"
                    v-on="listenerObject"
                  />
                  <span>WhatsApp</span>
                </label>
              </template>
              {{ restrictEditBranchEmployeeTitle }}
            </the-tooltip>
            <the-tooltip position="top">
              <template v-slot:trigger="{ listenerObject }">
                <label v-on="listenerObject" class="employee-basic__contact telegram">
                  <input
                    disabled
                    type="checkbox"
                    v-model="employeeBasic.hasTelegramByPhone"
                    v-on="listenerObject"
                  />
                  <span>Telegram</span>
                </label>
              </template>
              {{ restrictEditBranchEmployeeTitle }}
            </the-tooltip>
          </div>
          <div class="employee-basic__contact__row" v-else>
            <label class="employee-basic__contact whats-app">
              <input
                type="checkbox"
                v-model="employeeBasic.hasWhatsAppByPhone"
                v-on:input="checkProfileChanged"
              />
              <span>WhatsApp</span>
            </label>
            <label class="employee-basic__contact telegram">
              <input
                type="checkbox"
                v-model="employeeBasic.hasTelegramByPhone"
                v-on:input="checkProfileChanged"
              />
              <span>Telegram</span>
            </label>
          </div>
        </div>
        <div
          class="employee-basic__unit"
          v-bind:key="`access-${checkboxesKey}`"
          v-if="employeeBasic.hasEditableAccess"
        >
          <h2>Доступ</h2>
          <the-tooltip v-if="isBranch" position="top">
            <template v-slot:trigger="{ listenerObject }">
              <div v-if="!employeeBasic.isDismissed && !isOwner" v-on="listenerObject">
                <input-checkbox
                  disabled
                  title="Разрешить доступ к системе"
                  v-bind:value="employeeBasic.isAllowedLogin"
                  v-on="listenerObject"
                />
              </div>
            </template>
            {{ restrictEditBranchEmployeeTitle }}
          </the-tooltip>
          <input-checkbox
            v-else-if="!employeeBasic.isDismissed && !isOwner"
            title="Разрешить доступ к системе"
            v-model="employeeBasic.isAllowedLogin"
            v-on:input="checkProfileChanged"
          />
          <the-tooltip v-if="isBranch" position="top">
            <template v-slot:trigger="{ listenerObject }">
              <div v-if="!isOwner" v-on="listenerObject">
                <input-checkbox
                  disabled
                  title="Уволен"
                  v-bind:value="employeeBasic.isDismissed"
                  v-on:input="handleCheckboxClick('isDismissed', $event)"
                />
              </div>
            </template>
            {{ restrictEditBranchEmployeeTitle }}
          </the-tooltip>
          <input-checkbox
            v-else-if="!isOwner"
            title="Уволен"
            v-model="employeeBasic.isDismissed"
            v-on:input="checkProfileChanged"
          />
          <div
            class="employee-basic__date"
            v-if="employeeBasic.isDismissed"
            v-bind:class="{ 'disable-component': isBranch }"
          >
            <div class="employee-basic__date__label">Дата увольнения</div>
            <v-menu min-width="auto">
              <template v-slot:activator="{ on }">
                <div>
                  <button
                    class="employee-basic__date__activator"
                    title="Сменить дату"
                    type="button"
                    v-on="on"> {{ dismissedDateText }}</button>
                  <p
                    class="employee-basic__error-text"
                    role="alert"
                    v-bind:key="id"
                    v-for="(text, id) in dismissedDateInputErrors"
                  >{{ text }}</p>
                </div>
              </template>
              <v-date-picker
                first-day-of-week="1"
                color="#0489E0"
                locale="ru-ru"
                no-title
                v-bind:allowed-dates="allowedDates"
                v-model="employeeBasic.dismissedDate"
                v-on:input="checkProfileChanged"
              />
            </v-menu>
          </div>
          <template v-if="employeeBasic.isAllowedLogin && !employeeBasic.isDismissed">
            <div class="employee-basic__mail-section">
              <label
                class="employee-basic__group employee-basic__mail-field"
                v-bind:class="{ field_error: emailAddressInputErrors.length > 0, 'disable-component': isBranch }"
              >
                <span class="employee-basic__label">E-mail</span>
                <input
                  autocomplete="off"
                  class="employee-basic__input"
                  placeholder=""
                  type="email"
                  v-model="employeeBasic.emailAddress"
                  v-on:input="checkProfileChanged"
                />
                <p
                  class="employee-basic__error-text"
                  role="alert"
                  v-bind:key="id"
                  v-for="(text, id) in emailAddressInputErrors"
                >{{ text }}</p>
              </label>
              <template v-if="employeeBasic.hasEmail()">
                <the-tooltip v-if="isBranch" position="top">
                  <template v-slot:trigger="{ listenerObject }">
                    <button
                      disabled
                      class="employee-basic__button-password"
                      type="button"
                      v-on="listenerObject"
                    >
                      {{ changePasswordButtonTitle }}
                    </button>
                  </template>
                  {{ restrictEditBranchEmployeeTitle }}
                </the-tooltip>
                <button
                  v-else
                  class="employee-basic__button-password"
                  type="button"
                  v-on:click="onChangePassword"
                  v-bind:disabled="isAwaitRequest"
                >
                  {{ changePasswordButtonTitle }}
                </button>
              </template>
              <span
                v-if="employeeBasic.emailStatus"
                class="employee-basic__mail-status"
                v-bind:class="{
                  'Не подтвержден': 'noconfirmed',
                  'Ожидает подтверждения': 'waitingconfirmation',
                  Подтвержден: 'confirmed',
                }[employeeBasic.emailStatus] || ''"
              >
                {{ employeeBasic.emailStatus }}
              </span>
            </div>
          </template>
        </div>
        <the-tooltip v-if="isBranch" position="top">
          <template v-slot:trigger="{ listenerObject }">
            <button
              disabled
              class="employee-basic__button-save"
              type="button"
              v-on="listenerObject"
            >
              Сохранить
            </button>
          </template>
          {{ restrictEditBranchEmployeeTitle }}
        </the-tooltip>
        <button
          v-else
          class="employee-basic__button-save"
          type="submit"
          v-bind:disabled="isAwaitRequest || !hasChanges"
        >
          Сохранить
        </button>
      </form>
    </section>
  </employee-profile>
</template>

<script>
import InputCheckbox from '@/components/InputCheckbox.vue';
import TheSelect from '@/components/TheSelect.vue';
import InputPhone from '@/components/InputPhone.vue';
import InputIin from '@/components/InputIin.vue';
import InputDate from '@/components/InputDate.vue';
import dateMixin, { getISODateStringByDate } from '@/mixins/dateMixin';
import EmployeeProfile from '@/views/ClinicPanel/EmployeeProfile.vue';
import { EditEmployeePermissionListRequest, EmployeeBasicEditRequest } from '@/storage/gateways/EmployeeGateway';
import notifierMixin from '@/mixins/notifierMixin';
import debounce from 'lodash.debounce';
import ModalDialogPreventLeave from '@/components/ModalDialogPreventLeave.vue';
import preventLeaveWithoutConfirmMixin from '@/mixins/preventLeaveWithoutConfirmMixin';
import TheTooltip from '@/components/TheTooltip.vue';
import onBoardingMixin from '@/mixins/onBoardingMixin';
import { builtInDialogMixin, DialogResult } from '@/components/ClinicPanelDialog.vue';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.profileInputErrors ? vm.profileInputErrors[cause] : []
);

const SNILS_MASK = '###-###-### ##';

/**
 * @description Основные данные сотрудника.
 * @param {string}  birthDate
 * @param {string}  dismissedDate
 * @param {string}  emailAddress
 * @param {string}  emailStatus
 * @param {boolean} hasEditableAccess
 * @param {boolean} hasTelegramByPhone
 * @param {boolean} hasUser
 * @param {boolean} hasWhatsAppByPhone
 * @param {boolean} isAllowedCashbox
 * @param {boolean} isAllowedLogin
 * @param {boolean} isDismissed
 * @param {boolean} isEnabledWorkingScheduling
 * @param {string}  name
 * @param {string}  patronymic
 * @param {string}  phoneNumber
 * @param {string}  roleId
 * @param {string}  specialtyName
 * @param {string}  surname
 * @param {string}  iin
 * @param {string}  snils
 * @constructor
 */
function EmployeeBasic(
  birthDate = '',
  dismissedDate = '',
  emailAddress = '',
  emailStatus = '',
  hasEditableAccess = true,
  hasTelegramByPhone = false,
  hasUser = false,
  hasWhatsAppByPhone = false,
  isAllowedCashbox = false,
  isAllowedLogin = false,
  isDismissed = false,
  isEmailVerified = false,
  isEnabledWorkingScheduling = false,
  name = '',
  patronymic = '',
  phoneNumber = '',
  roleId = '',
  specialtyName = '',
  surname = '',
  iin = '',
  snils = '',
) {
  /**
   * @description Получить снилс с разделителями.
   * @param {string} value
   * @returns {string}
   */
  const getSnilsWithDelimiter = (value) => {
    if (value.length !== 11) {
      return value;
    }
    const val = value.replace(/[^\d]/g, '').split('');
    return SNILS_MASK.split('').map((char) => {
      if (char === '#') {
        return val.shift() || '';
      }
      return char;
    }).join('');
  };
  this.initialRoleId = roleId;
  this.updateInitialRole = () => {
    this.initialRoleId = this.roleId;
  };
  let initialEmail = emailAddress;
  this.hasEmail = () => !!initialEmail;
  this.updateInitialEmail = () => {
    initialEmail = this.emailAddress;
  };

  this.initialIsDismissed = isDismissed;
  this.updateInitialIsDismissed = () => {
    this.initialIsDismissed = this.isDismissed;
  };

  this.birthDate = birthDate;
  this.dismissedDate = dismissedDate;
  this.emailAddress = emailAddress;
  this.emailStatus = emailStatus;
  this.hasEditableAccess = hasEditableAccess;
  this.hasTelegramByPhone = hasTelegramByPhone;
  this.hasUser = hasUser;
  this.hasWhatsAppByPhone = hasWhatsAppByPhone;
  this.isAllowedCashbox = isAllowedCashbox;
  this.isAllowedLogin = isAllowedLogin;
  this.isEmailVerified = isEmailVerified;
  this.isDismissed = isDismissed;
  this.name = name;
  this.patronymic = patronymic;
  this.phoneNumber = phoneNumber;
  this.roleId = roleId;
  this.specialtyName = specialtyName;
  this.surname = surname;
  this.iin = iin;
  this.snils = getSnilsWithDelimiter(snils);
  this.isEnabledWorkingScheduling = isEnabledWorkingScheduling;

  this.getSnilsWithoutDelimiter = () => this.snils.replace(/[-\s]/g, '');

  this.toString = () => JSON.stringify({
    birthDate: this.birthDate,
    dismissedDate: this.dismissedDate,
    emailAddress: this.emailAddress,
    emailStatus: this.emailStatus,
    hasEditableAccess: this.hasEditableAccess,
    hasTelegramByPhone: this.hasTelegramByPhone,
    hasUser: this.hasUser,
    hasWhatsAppByPhone: this.hasWhatsAppByPhone,
    isAllowedCashbox: this.isAllowedCashbox,
    isAllowedLogin: this.isAllowedLogin,
    isEmailVerified: this.isEmailVerified,
    isDismissed: this.isDismissed,
    name: this.name,
    patronymic: this.patronymic,
    phoneNumber: this.phoneNumber,
    roleId: this.roleId,
    specialtyName: this.specialtyName,
    surname: this.surname,
    iin: this.iin,
    snils: getSnilsWithDelimiter(this.snils),
    isEnabledWorkingScheduling: this.isEnabledWorkingScheduling,
  });

  this.initial = this.toString();
  this.isChanged = () => this.toString() !== this.initial;

  /**
   * @description Обновить.
   * @returns {void}
   */
  this.refresh = () => {
    this.initial = this.toString();
  };
}

/**
 * @description Компонент пункта профиля сотрудника "Основное".
 * @type {Vue}
 */
export default {
  computed: {
    /**
     * @description Имеет изменения
     * @returns {boolean}
     */
    hasChanges() {
      return this.employeeBasic.isChanged();
    },
    /**
     * @description Сообщение запрета редактирования филиального сотрудника.
     * @returns {string}
     */
    restrictEditBranchEmployeeTitle() {
      return 'Редактирование недоступно.'
        + ' Внесение изменений возможно только в основном филиале трудоустройства сотрудника';
    },
    changePasswordButtonTitle() {
      return this.employeeBasic.isEmailVerified ? 'Сбросить пароль' : 'Отправить пароль';
    },
    needPreventLeave() {
      return this.profileChanged;
    },
    /**
     * @description Дата увольнения сотрудника.
     * @type {string}
     */
    dismissedDateText() {
      if (this.employeeBasic.dismissedDate) {
        return this.getFullDate(this.employeeBasic.dismissedDate);
      }
      return 'Укажите дату';
    },
    employeeId: (vm) => parseInt(vm.$route.params.id, 10),
    /**
     * @description Является ли сотрудник администратором.
     * @return {boolean}
     */
    isAdmin() {
      return this.employeeBasic.roleId === 'admin';
    },
    /**
     * @description Является ли сотрудник ассистентом.
     * @return {boolean}
     */
    isAssistant() {
      return this.employeeBasic.roleId === 'assistant';
    },

    /**
     * @description Является ли сотрудник руководителем.
     * @return {boolean}
     */
    isClinicManager() {
      return this.employeeBasic.roleId === 'clinic-manager';
    },
    /**
     * @description Форма открыта для редактирования.
     * @returns {boolean}
     */
    isEdit() {
      return this.initialId !== null;
    },
    birthDateInputErrors: resolveInputErrors('birth-date'),
    dismissedDateInputErrors: resolveInputErrors('dismissed-date'),
    emailAddressInputErrors: resolveInputErrors('email'),
    roleIdInputErrors: resolveInputErrors('employee-role'),
    nameInputErrors: resolveInputErrors('name'),
    patronymicInputErrors: resolveInputErrors('patronymic'),
    phoneNumberInputErrors: resolveInputErrors('phone'),
    surnameInputErrors: resolveInputErrors('surname'),
    iinInputErrors: resolveInputErrors('iin'),
  },
  components: {
    TheTooltip,
    ModalDialogPreventLeave,
    InputDate,
    InputPhone,
    InputIin,
    TheSelect,
    InputCheckbox,
    EmployeeProfile,
  },
  created() {
    this.fetchProfileOptions();
    this.viewEmployeePermissions();
  },
  data() {
    return {
      employeeBasic: new EmployeeBasic(),
      employeeRoleList: [],
      profileChanged: false,
      isAwaitRequest: false,
      profileInputErrors: {},
      isOwner: false,
      isBranch: false,
      permissions: [],
      dataWasLoad: false,
      checkboxesKey: 1,
      isClearWorkScheduleConfirmed: false,
      hasBranchWorkPlaces: false,
    };
  },
  currentDate: getISODateStringByDate(new Date()),
  methods: {
    /**
     * @description Получить основные данные профиля сотрудника.
     * @returns {void}
     */
    fetchEmployeeBasic() {
      const onFail = (error) => {
        this.notifyFail(error.title);
      };
      const onSuccess = async (employee) => {
        this.employeeBasic = new EmployeeBasic(
          employee.birthDate,
          employee.dismissedDate,
          employee.email,
          employee.emailStatus,
          employee.hasEditableAccess,
          employee.hasTelegramByPhone,
          employee.hasUser,
          employee.hasWhatsAppByPhone,
          employee.isAllowedCashbox,
          employee.isAllowedLogin,
          employee.isDismissed,
          employee.isEmailVerified,
          employee.isEnabledWorkingScheduling,
          employee.name,
          employee.patronymic,
          employee.phone.replace(/[ _)(-]/g, ''),
          employee.roleId,
          employee.specialityName,
          employee.surname,
          employee.iin,
        );
        this.hasBranchWorkPlaces = employee.hasBranchWorkPlaces;
        const failurePairs = employee.errors.causes.map((cause) => [cause.source, cause.details]);
        this.profileInputErrors = Object.fromEntries(failurePairs) || {};
        this.specialtyId = employee.specialtyId;
        this.isOwner = employee.isOwner;
        this.isBranch = employee.isBranch;
        this.dataWasLoad = true;
      };
      const response = this.$employeeGateway.getById(this.employeeId);
      response.then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Получить опции для профиля.
     * @returns {void}
     */
    fetchProfileOptions() {
      const onResponse = (result) => {
        this.employeeRoleList = result
          .employeeRoleList
          .map(({ name: title, id: value, default_permissions: defaultPermissions }) => (
            { title, value, defaultPermissions }
          ));
        this.fetchEmployeeBasic();
      };
      this.$suggestionGateway.getEmployeeCreation().then(onResponse);
    },
    /**
     * @description Получить список прав сотрудника.
     * @returns {void}
     */
    viewEmployeePermissions() {
      const onSuccess = (permissions) => {
        this.permissions = permissions;
      };
      this.$employeeGateway
        .viewPermissionListByEmployeeId(this.employeeId)
        .then((result) => result.fold(this.notifyFail, onSuccess));
    },
    /**
     * @description Функция описывающая условие доступности выбора дат в datepicker
     * @param {string} candidate Строка с датой в формате Y-m-d
     * @return {boolean}
     */
    allowedDates(candidate) {
      return candidate <= this.$options.currentDate;
    },
    /**
     * @description Обработать событие изменения пароля.
     * @returns {void}
     */
    onChangePassword() {
      const onFail = (error) => {
        this.profileInputErrors = error.allCauses();
        if (!error.hasCauses()) {
          this.notifyFail(error.getTitle());
        }
      };
      const onSuccess = (result) => {
        this.notifySuccess(result.title);
      };
      this
        .$employeeGateway
        .changePassword(this.employeeId)
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Выполнить редактирование основных параметров сотрудника.
     * @returns {Promise|null}
     */
    async onSubmitEmployeeBasicEdit() {
      const request = this.makeEmployeeBasicEditingRequest();
      if (
        !this.employeeBasic.initialIsDismissed
        && this.employeeBasic.isDismissed
        && this.hasBranchWorkPlaces
      ) {
        const dialog = await this.showDialog(
          'Сотрудник будет уволен из всех филиалов сети. Продолжить?',
          DialogResult.NO,
          DialogResult.YES,
        );
        if (dialog.result !== DialogResult.YES) {
          this.employeeBasic.isDismissed = false;
          return;
        }
      }
      this.isAwaitRequest = true;
      const onFail = (error) => {
        this.profileInputErrors = error.allCauses();
        if (!error.hasCauses()) {
          this.notifyFail(error.getTitle());
        }
        this.isAwaitRequest = false;
      };
      const onSuccess = (result) => {
        this.editEmployeePermission(request.getPermissions()).then(() => {
          this.notifySuccess(result.title);
          this.profileInputErrors = {};
          this.isAwaitRequest = false;
        });
        const { title, body } = result.onboarding_status;
        this.checkAndUpdate(title, body);
        this.employeeBasic.updateInitialEmail();
        this.employeeBasic.updateInitialRole();
        this.employeeBasic.updateInitialIsDismissed();
        this.employeeBasic.refresh();
        this.checkProfileChanged();
      };
      const response = this.$employeeGateway.editBasic(request);
      response.then((result) => result.fold(onFail, onSuccess));
      // eslint-disable-next-line consistent-return
      return response;
    },
    /**
     * @description Отправить запрос на редактирование разрешений сотрудника
     * @return {Promise}
     */
    editEmployeePermission(request) {
      return new Promise((resolve) => {
        const onSuccess = () => {
          resolve();
        };
        this
          .$employeeGateway
          .editPermissionListByEmployeeId(request)
          .then((result) => result.fold(this.notifyFail, onSuccess));
      });
    },
    /**
     * @description Создать запрос на редактирование.
     * @returns {EmployeeBasicEditRequest}
     */
    makeEmployeeBasicEditingRequest() {
      const additional = [];
      const excluded = [];
      const getIds = (permissions, value) => permissions
        .filter((candidate) => candidate.value === value)
        .map((permission) => permission.id);
      this.permissions.forEach((group) => {
        additional.push(...getIds(group.permissions, 'additional'));
        excluded.push(...getIds(group.permissions, 'excluded'));
      });
      const permissionsRequest = new EditEmployeePermissionListRequest(
        this.employeeId,
        additional,
        excluded,
      );
      return new EmployeeBasicEditRequest(
        this.employeeId,
        this.formatDateToISO(this.employeeBasic.birthDate),
        this.employeeBasic.dismissedDate,
        this.employeeBasic.emailAddress,
        this.employeeBasic.hasTelegramByPhone,
        this.employeeBasic.hasWhatsAppByPhone,
        this.employeeBasic.isAllowedCashbox,
        this.employeeBasic.isAllowedLogin,
        this.employeeBasic.isDismissed,
        this.employeeBasic.isEnabledWorkingScheduling,
        this.employeeBasic.name,
        this.employeeBasic.patronymic,
        this.employeeBasic.phoneNumber,
        this.employeeBasic.roleId,
        this.employeeBasic.specialtyName,
        this.employeeBasic.surname,
        this.employeeBasic.iin,
        this.employeeBasic.getSnilsWithoutDelimiter(),
        permissionsRequest,
      );
    },
    /**
     * @description Нужно показать диалог об удалении смен на будущее.
     * @param {string} newRoleId
     * @returns {boolean}
     */
    needShowClearWorkScheduleDialog(newRoleId) {
      if (this.isClearWorkScheduleConfirmed) {
        return false;
      }
      if (newRoleId === this.employeeBasic.initialRoleId) {
        return false;
      }
      return ['admin', 'doctor'].includes(this.employeeBasic.initialRoleId);
    },
    /**
     * @description Обработать изменение роли.
     * @type {string} roleId Идентификатор роли.
     * @returns {void}
     */
    async onInputRole(roleId) {
      const prevRoleId = this.employeeBasic.roleId;
      this.employeeBasic.roleId = roleId;
      if (this.needShowClearWorkScheduleDialog(roleId)) {
        let dialogTitle = 'График работы будет очищен. Изменить роль?';
        const initialRole = this.employeeRoleList.find(
          ({ value }) => value === this.employeeBasic.initialRoleId,
        );
        if (initialRole) {
          dialogTitle = `График работы для роли "${initialRole.title}" будет очищен. Изменить роль?`;
        }
        const dialog = await this.showDialog(dialogTitle, DialogResult.CANCEL, DialogResult.CHANGE);
        if (dialog.result !== DialogResult.CHANGE) {
          this.employeeBasic.roleId = prevRoleId;
          return;
        }
        this.isClearWorkScheduleConfirmed = true;
      }
      const { defaultPermissions } = this
        .employeeRoleList
        .find((candidate) => candidate.value === roleId);
      const mapPosition = (candidate) => ({
        ...candidate,
        value: 'by-positions',
        isContains: defaultPermissions.includes(candidate.id),
      });
      this.permissions = this
        .permissions
        .map((group) => ({ ...group, permissions: group.permissions.map(mapPosition) }));
      this.checkProfileChanged();
    },
    async saveAndLeave() {
      const result = await this.onSubmitEmployeeBasicEdit();
      result.forEach((message) => {
        this.notifySuccess(message);
        this.actionAfterClosingDialogLeaveConfirm();
      });
      this.isShownDialogLeaveConfirm = false;
    },
    /**
     * @description Проверить наличие изменений.
     * @returns {void}
     */
    checkProfileChanged: debounce(function _() {
      this.profileChanged = this.employeeBasic.isChanged();
    }, 300),
  },
  mixins: [
    dateMixin,
    builtInDialogMixin,
    notifierMixin,
    preventLeaveWithoutConfirmMixin,
    onBoardingMixin,
  ],
  name: 'ClinicPanelEmployeeProfileBasic',
};
</script>

<style lang="scss">
@use "@/scss/buttons";

.disable-component {
  pointer-events: none;
}

.employee-basic {
  display: grid;
  row-gap: 20px;
  width: 100%;
  margin: 37px 0 50px;
  max-width: 700px;
  &__status-title {
    color: #90a0b7;
  }
  &__form {
    display: flex;
    flex-direction: column;
    gap: 34px;
  }
  &__unit {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  &__date {
    &__label {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #90A0B7;
      margin: 0 0 3px 0;
    }
    &__activator {
      padding: 10px 50px 10px 10px;
      border: 1px solid #C2CFE0;
      border-radius: 4px;
      font-size: 16px;
      background-image: url("@/assets/img/calendar-grey.svg");
      background-position: right 10px center;
    }
  }
  &__row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 10px;
  }
  &__mail-section {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: end;
    gap: 8px 20px;
  }
  &__mail-field {
    flex: 1;
    width: 100%;
  }
  & &__mail-status {
    display: flex;
    align-items: center;
    column-gap: 5px;
    align-self: center;
    grid-row: 2/3;
    color: var(--reading-color);
    &::before {
      content: '';
      flex-shrink: 0;
      width: 18px;
      height: 20px;
      background-repeat: no-repeat;
      background-position: 50%;
      background-size: contain;
    }
    &.confirmed::before {
      background-image: url("@/assets/img/checked/checked-green.svg");
      background-size: 16px 16px;
    }
    &.noconfirmed::before {
      background-image: url("@/assets/img/status/exit-red.svg");
      background-size: 22px 22px;
    }
    &.waitingconfirmation::before {
      background-image: url("@/assets/img/nav/time.svg");
    }
  }
  &__group {
    display: flex;
    flex-direction: column;
    &.field_error {
      .employee-basic__label {
        color: var(--warning-color);
      }
    }
  }
  &__label {
    color: #90A0B7;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
  }
  &__multiline {
    flex: 1;
    &.explanation {
      .multiline-select__row:first-child {
        .multiline-select__placeholder {
          cursor: pointer !important;
          pointer-events: auto;
          &:after {
            content: "?";
            font-size: 13px;
            margin: 0 0 0 5px;
          }
        }
      }
    }
  }
  &__input {
    background: #ffffff;
    border: 1px solid #c2cfe0;
    border-radius: 4px;
    outline: none;
    height: 40px;
    width: 100%;
    padding: 0 10px;
    appearance: none;
    font-size: 16px;
    color: #192a3e;
    font-weight: 400;
    &:focus {
      color: #192a3e;
      background-color: #fff;
      border: 2px solid #0489e0;
      outline: 0;
    }
    &:disabled {
      background-color: #fff;
    }
  }
  &__error-text {
    color: var(--warning-color);
    font-size: 12px;
    line-height: 12px;
    padding: 0;
    margin: 5px 0 0 0;
    background-color: transparent!important;
  }
  &__contacts {
    display: grid;
    grid-template-columns: 0.97fr 2fr;
    align-items: flex-start;
    grid-gap: 10px;
  }
  &__contact {
    display: flex;
    align-items: center;
    background-color: #eef2f8;
    border-radius: 4px;
    padding: 8px;
    cursor: pointer;
    &__row {
      margin: 17.5px 0 0 0;
    }
    &.whats-app {
      margin: 0 10px 0 0;
    }
    &:before {
      content: "";
      width: 24px;
      height: 24px;
      background-repeat: no-repeat;
      background-size: contain;
      margin: 0 10px 0 0;
    }
    &.whats-app:before {
      background-image: url("@/assets/img/social/whats-app-grey.svg");
    }
    &.telegram:before {
      background-image: url("@/assets/img/social/telegram-grey.svg");
    }
    &__row {
      display: flex;
      flex-direction: row;
      position: relative;
    }
    &__text {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      background-color: white;
      color: rgba(0,0,0,.87);
      padding: 5px;
      border-radius: 5px;
      box-shadow: 0 0 20px rgba(54, 77, 92, 0.18);
      max-width: 250px;
      font-size: 12px;
    }
    &__indent {
      margin: 15px 0 0 0;
      .multiline-select {
        grid-gap: 33px;
      }
    }
    &> input {
      position: absolute;
      z-index: -1;
      opacity: 0;
      &:not(:disabled):not(:checked) + span:hover::after {
        border-color: #0489e0;
      }
      &:not(:disabled):active + span::after {
        background-color: #90a0b7;
        border-color: #90a0b7;
      }
      &:focus:not(:checked) + span::after {
        border-color: #0489e0;
      }
      &:checked + span::after {
        background-color: #0489e0;
        border-color: #0489e0;
        background-image: url("@/assets/img/checked/checked-white-top.svg");
      }
    }
    &> span {
      display: inline-flex;
      align-items: center;
      user-select: none;
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      &::after {
        content: "";
        display: inline-block;
        width: 24px;
        height: 24px;
        flex-shrink: 0;
        flex-grow: 0;
        border: 1px solid #90a0b7;
        border-radius: 4px;
        margin: 0 0 0 10px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 70%;
        background-color: #ffffff;
      }
    }
  }
  &__password {
    position: relative;
    & > .employee-basic__input {
      padding-right: 40px;
    }
    &__toggle {
      background-image: url("@/assets/img/eye-closed.svg");
      background-position: center;
      height: 40px;
      position: absolute;
      right: 0;
      top: 0;
      width: 40px;
      &.active {
        background-image: url("@/assets/img/eye-open.svg");
      }
      cursor: pointer;
    }
  }
  &__button-save {
    @include buttons.btn-blue(100%, 48px, 16px);
    min-height: 48px;
    max-width: 174px;
    padding: 0;
    margin: 10px 0 0 0;
    &:disabled {
      background-color: var(--unfocus-color);
    }
    &.disabled {
      background-color: var(--unfocus-color);
    }
  }
  &__button-password {
    @include buttons.btn-blue(100%, 40px, 16px);
    min-width: 184px;
    max-width: 184px;
    &:disabled {
      background-color: var(--unfocus-color);
    }
    &.disabled {
      background-color: var(--unfocus-color);
    }
  }
}

@media screen and (max-width: 520px) {
  .employee-basic {
    &__row {
      grid-template-columns: 1fr;
    }
    &__contacts {
      grid-template-columns: 1fr;
      &.align {
        align-items: center;
        .employee-basic__contact__row {
          margin: 0 0 0 0;
        }
      }
    }
  }
}
@media screen and (max-width: 480px) {
  .employee-basic {
    &__contact {
      width: max-content;
      &.whats-app {
        margin: 0 0 10px 0;
      }
      &__row {
        flex-direction: column;
      }
    }
    &__mail-section {
      grid-template-columns: 1fr;
    }
    &__mail-status {
      margin-bottom: 12px;
    }
  }
}
</style>
